import {useEffect, useMemo, useState} from "react";
import {Box, CircularProgress, Divider, Grid, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import {
    ArrowLeft,
    Category as CategoryIcon,
    Clear as ClearIcon, ForkLeft, JoinLeft, KeyboardDoubleArrowLeft,
    Notifications,
    NotificationsOff,
    Search as SearchIcon, Security
} from "@mui/icons-material";
import GHEProduct from "../../../../common/GHEProduct";

export function StepCategoriaEProdutos({ control, register, errors, setValue, getValues, watch, selectedCard, cards, selectedCardInfo, allowInteraction, exibirAlerta }) {
    const [search, setSearch] = useState("");

    const [maxCategoriaPontoAlerta, setMaxCategoriaPontoAlerta] = useState(1)
    const [campoAtivado, setCampoAtivado] = useState(false);

    const periodoGlobal = watch(`categorias[${selectedCard}].periodo`);
    const quantidadeMaximaGlobal = watch(`categorias[${selectedCard}].quantidade_maxima`);
    const alertaGlobal = watch(`categorias[${selectedCard}].ponto_alerta`);

    const quantidadeMaxima = Number(watch(`categorias[${selectedCard}].quantidade_maxima`)) || 0;

    useEffect(() => {
        if (maxCategoriaPontoAlerta <= getValues(`categorias[${selectedCard}].ponto_alerta`)) {
            setValue(`categorias[${selectedCard}].ponto_alerta`, maxCategoriaPontoAlerta - 1)
        }
    }, [maxCategoriaPontoAlerta]);

    useEffect(() => {
        if (getValues(`categorias[${selectedCard}].periodo`)) setMaxCategoriaPontoAlerta(getValues(`categorias[${selectedCard}].periodo`));
    }, [selectedCard, campoAtivado]);

    useEffect(() => {
        if (quantidadeMaxima > 1) {
            setCampoAtivado(true);
            const atual = getValues(`categorias[${selectedCard}].ponto_alerta`);
            if (!atual || Number(atual) < 1) {
                setValue(`categorias[${selectedCard}].ponto_alerta`, 1);
            }
        }
    }, [quantidadeMaxima, selectedCard]);

    const maxVidaUtilCategoria = useMemo(() => {
        const produtos = selectedCardInfo?.produtos ?? [];
        if (produtos.length === 0) return null;

        const valores = produtos
            .map(p => Number(p.vida_util))
            .filter(v => !isNaN(v) && v > 0);

        return valores.length > 0 ? Math.max(...valores) : null;
    }, [selectedCardInfo]);

    return (
        <>
            {cards.length > 0 && cards ?
                !selectedCard ?
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '300px',
                                p: 3,
                                border: '2px dashed',
                                borderColor: 'divider',
                                borderRadius: 2,
                                bgcolor: 'white'
                            }}
                        >
                            <KeyboardDoubleArrowLeft sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
                            <Typography variant="body1" color="text.secondary" textAlign="center">
                                Nenhuma categoria selecionada
                            </Typography>
                            <Typography variant="body2" color="text.disabled" textAlign="center" mt={1}>
                                Escolha uma categoria no(s) Card(s) ao lado
                            </Typography>
                        </Box>
                    </>
                :
                    <>
                        <Typography variant='h2'>{selectedCardInfo?.nome}</Typography>
                        <Typography variant='body2' sx={{ my: 1 }}>Preencha os campos abaixos com as informações comuns para esta categoria neste GHE.</Typography>
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="stretch"
                            spacing={2}
                        >
                            <Grid item xs={12} md={3}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    margin="dense"
                                    size='small'
                                    label="Quantidade"
                                    type='number'
                                    required
                                    name={`categorias[${selectedCard}].quantidade_maxima`}
                                    autoComplete='off'
                                    error={errors[`categorias[${selectedCard}].quantidade_maxima`] && true}
                                    helperText={errors[`categorias[${selectedCard}].quantidade_maxima`] ? 'A Quantidade é obrigatória.' : 'Quantidade de EPIs que podem ser usados/entregues.'}
                                    fullWidth
                                    variant="outlined"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setValue(`categorias[${selectedCard}].quantidade_maxima`, value);
                                    }}
                                    inputProps={{ min: 1 }}
                                    value={watch(`categorias[${selectedCard}].quantidade_maxima`)}
                                    disabled={!allowInteraction}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    margin="dense"
                                    size='small'
                                    label="Período"
                                    type='number'
                                    required
                                    name={`categorias[${selectedCard}].periodo`}
                                    autoComplete='off'
                                    error={errors[`categorias[${selectedCard}].periodo`] && true}
                                    helperText={
                                        errors[`categorias[${selectedCard}].periodo`]
                                            ? 'O Período é obrigatório.'
                                            : maxVidaUtilCategoria
                                                ? `Período em dias (máx. ${maxVidaUtilCategoria} - vida útil do produto).`
                                                : 'Período em dias que os EPIs podem ser usados/entregues.'
                                    }
                                    fullWidth
                                    variant="outlined"
                                    onChange={(e) => {
                                        let value = Number(e.target.value);

                                        if (maxVidaUtilCategoria && value > maxVidaUtilCategoria) {
                                            value = maxVidaUtilCategoria;
                                            exibirAlerta?.(
                                                `O período não pode ser maior que a vida útil do produto (${maxVidaUtilCategoria} dias).`,
                                                'warning'
                                            );
                                        }

                                        setMaxCategoriaPontoAlerta(value);
                                        setValue(`categorias[${selectedCard}].periodo`, value);
                                    }}
                                    inputProps={{ min: 1, max: maxVidaUtilCategoria ?? undefined }}
                                    value={watch(`categorias[${selectedCard}].periodo`)}
                                    disabled={!allowInteraction}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    disabled={!campoAtivado || !allowInteraction}
                                    margin="dense"
                                    size="small"
                                    label="Ponto de Alerta"
                                    // defaultValue={0}
                                    type="number"
                                    required
                                    name={`categorias[${selectedCard}].ponto_alerta`}
                                    autoComplete="off"
                                    variant="outlined"
                                    inputProps={{
                                        min: 1,
                                        max: Math.max(1, (maxCategoriaPontoAlerta || 0) - 1)
                                    }}
                                    onChange={(e) => {
                                        setValue(`categorias[${selectedCard}].ponto_alerta`, e.target.value)
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton
                                                    aria-label="toggle campo visibility"
                                                    onClick={() => setCampoAtivado((atual) => {
                                                        atual ? setValue(`categorias[${selectedCard}].ponto_alerta`, 0) : setValue(`categorias[${selectedCard}].ponto_alerta`, 1);
                                                        return !atual
                                                    })
                                                    }
                                                    edge="start"
                                                >
                                                    {campoAtivado ? <Notifications /> : <NotificationsOff />}                                          </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    value={watch(`categorias[${selectedCard}].ponto_alerta`)}
                                />
                            </Grid>
                        </Grid>
                        <Divider variant='middle' />
                        <Typography variant='h3'>Produtos</Typography>
                        <Typography variant='body2'>Abaixo estão listados os EPIs que fazem parte da categoria selecionada. Ao alterar as informações individuais dos EPIs, estas informações irão sobrepor as comuns do grupo.</Typography>
                        <Divider variant='middle' />

                        <TextField
                            size="small"
                            placeholder="Buscar EPI..."
                            variant="outlined"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            sx={{ my: 2 }}
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                                endAdornment: search && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => setSearch('')}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        {selectedCardInfo?.produtos ? (
                            selectedCardInfo.produtos
                                .sort((a, b) => a.nome.localeCompare(b.nome))
                                .filter((produto) =>
                                    produto.nome?.toLowerCase().includes(search.toLowerCase())
                                )
                                .map((produto, index) => (
                                    <GHEProduct
                                        key={produto.id}
                                        control={control}
                                        register={register}
                                        errors={errors}
                                        setValue={setValue}
                                        getValues={getValues}
                                        index={index}
                                        produto={produto}
                                        watch={watch}
                                        globalPeriod={periodoGlobal}
                                        globalAlert={alertaGlobal}
                                        globalQuantity={quantidadeMaximaGlobal}
                                        allowInteraction={allowInteraction}
                                        maxPontoAlerta={maxCategoriaPontoAlerta}
                                        exibirAlerta={exibirAlerta}
                                    />
                                ))
                        ) : (
                            <Typography>
                                <CircularProgress /> Carregando...
                            </Typography>
                        )}
                    </> :
                getValues('id_empresa') &&
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '300px',
                            p: 3,
                            border: '2px dashed',
                            borderColor: 'divider',
                            borderRadius: 2,
                            bgcolor: 'white'
                        }}
                    >
                        <Security sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
                        <Typography variant="body1" color="text.secondary" textAlign="center">
                            Nenhuma categoria selecionada
                        </Typography>
                        <Typography variant="body2" color="text.disabled" textAlign="center" mt={1}>
                            Adicione e escolha uma categoria ao lado
                        </Typography>
                    </Box>
                </>

            }
        </>
    )
}
